import { Alert, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isElectron } from 'utils/isElectron';

export enum UpdateStatus {
  NONE = 'none',
  CHECKING = 'checking',
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not-available',
  DOWNLOADED = 'downloaded',
}

export function Updater() {
  const { t } = useTranslation();
  const [updateStatus, setUpdateStatus] = useState<UpdateStatus>(UpdateStatus.NONE);

  useEffect(() => {
    if (!isElectron()) return;

    window.electron?.onUpdateChecking?.(() => setUpdateStatus(UpdateStatus.CHECKING));
    window.electron?.onUpdateAvailable?.(() => setUpdateStatus(UpdateStatus.AVAILABLE));
    window.electron?.onUpdateNotAvailable?.(() => setUpdateStatus(UpdateStatus.NOT_AVAILABLE));
    window.electron?.onUpdateDownloaded?.(() => setUpdateStatus(UpdateStatus.DOWNLOADED));
  }, []);

  const handleUpdateAndRestart = async () => {
    await window.electron?.updateAndRestartApp();
  };

  if (!isElectron() || updateStatus !== UpdateStatus.DOWNLOADED) return <></>;

  return (
    <Alert
      variant="filled"
      severity="info"
      sx={{ mb: 3, alignItems: 'center' }}
      action={
        <Button color="inherit" size="small" onClick={handleUpdateAndRestart}>
          Restart now
        </Button>
      }
    >
      <Typography>
        {t(
          'newUpdateAvailableNotification',
          'New update available. Restart the application to install the latest version.'
        )}
      </Typography>
    </Alert>
  );
}
